import CreateBookingRoleRequest from '@/models/BookingRoles/CreateBookingRoleRequest';
import Gender from '@/models/Shared/Gender';
import GeoPoint from '@/models/Shared/GeoPoint';
import MaritalStatus from '@/models/Shared/MaritalStatus';
import IWorkerAvailability from '@/models/Workers/IWorkerAvailability';
import IAddressLine from '@/models/Shared/IAddressLine';
import WorkerStatus from '@/models/Workers/WorkerStatus';
import AvailabilityRestriction from '@/models/Workers/AvailabilityRestriction';
import WorkType from '@/models/Shared/WorkType';

export default class CreateWorkerRequest implements IWorkerAvailability, IAddressLine {
    status: WorkerStatus = WorkerStatus.Pending;
    legacyId: string;
    firstName= '';
    lastName = '';
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo = false;
    biography = '';
    summary = '';
    mobilePhoneNumber = '';
    otherPhoneNumber = '';  
    emailAddress = '';      
	dateOfBirth: string;              
	gender: Gender = Gender.Unknown;                 
	maritalStatus: MaritalStatus = MaritalStatus.Unknown;            
	nationality = "British";           
    nationalInsuranceNumber = '';  
    workTypes: WorkType[] = [];   
    isUnspentConvictions = false;
    convictionDetails = '';
    availability: string[] = [];
    availabilityRestriction: AvailabilityRestriction = AvailabilityRestriction.None;
    isAgreedToMarketing = true;
    isDriver = false;
    maximumPassengers = 0;
	emergencyContactName ='';
    emergencyContactPhoneNumber ='';
    payrollNumber ='';
    defaultBranchId = '';
    defaultDeskId = '';
    tempDocumentUris?: string[];
    matchedSkills?: MatchedAttributeForWorkerCreation[];
    matchedQualifications?: MatchedAttributeForWorkerCreation[];
    matchedPositions?: MatchedAttributeForWorkerCreation[];
    agenticTaskId?: string;
}

// Consolidated interface for all attribute types (skills, qualifications, positions)
export interface MatchedAttributeForWorkerCreation {
  attributeId: string;
  name: string;
  source: number;
  agentMatchReason?: string;
  agentMatchConfidence?: number;
  isVerified: boolean;
  // Work type flags and payRate for positions only
  isTemp?: boolean;
  isPerm?: boolean;
  payRate?: number;
}